import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=36c68363&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=36c68363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c68363",
  null
  
)

export default component.exports